<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title--Front-Matter-"><span class="sz"><b>The Phoenix Code</b></span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="sz">Catherine Asaro</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><img alt="logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?411cbf42